import { Component, EventEmitter, Input, Output, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LayoutUtilsService } from 'src/app/core/layout-utils.service';
import { AuthService } from 'src/app/modules/auth/_services/auth.service';
import { Artikel } from '../../store/models/artikel';
import { Warenkorb } from '../../store/models/warenkorb';
import { Webshops } from '../../store/models/webshops';
import { WarenkorbsService } from '../../webshops/warenkorbs/shared/warenkorbs.service';
import { ArtikelsService } from '../shared/artikels.service';

/*class SelectedArtikel {
    artikel: any;
    menge: number;
    isMatrixArtikel: boolean;
}*/

@Component({
    selector: 'kkis-app-webshop-artikelzubehoer',
    templateUrl: './artikelzubehoer.component.html',
    styleUrls: ['./artikelzubehoer.component.scss']
})
export class ArtikelzubehoerComponent implements OnInit {

    @Input()
    artikelKennung: number;

    @Output()
    numberWarenkorbItems: EventEmitter<number> = new EventEmitter<number>(); //Eric

    // User
    loggedInUser: Webshops.ILoggedInUser;

    // Warenkorb
    warenkorb: Warenkorb.IWarenkorbDto;

    // Artikel
    artikel: Artikel.IArtikelDto[];

    responsiveOptions;

    // (from local <<NOT>> FROM DATABASE)
    imgDummy: string = "assets/media/svg/files/no-image.svg";

    // Dialog
    dialogWidth: string;
    dialogHeight: string;

    // Utils
    isLoading: boolean = true;
    isLoggedIn: boolean = false;
    isSubmitted: boolean = false;

    constructor(
        private dialog: MatDialog,
        private layoutUtilsService: LayoutUtilsService,
        private authService: AuthService,
        private warenkorbsService: WarenkorbsService,
        private artikelsService: ArtikelsService,
    ) { }

    ngOnInit(): void {

        //ToDo: Kennung als Parameter übergeben 
        //console.log('jetzt init mit kennung: '+this.artikelKennung);
        this.artikelsService.getListArtikelZubehoerForArtikel(this.artikelKennung).subscribe(res => {
            if (res) {
                this.artikel = res;
                this.isLoading = false;
                $('.zub_artikelcard').scrollTop(0);
            } else {
                this.isLoading = false;
            }
        });

        this.authService.isAuthenticated$.subscribe(x => {
            this.isLoggedIn = x;
        });

    }
 

    onAddToWarenkorb(artikel, menge: number, isMatrixArtikel: boolean = false) {
        if (this.isLoggedIn) {
            this.isSubmitted = true;

            let newPosition = {} as Warenkorb.IAddPositionDto;
    
            newPosition.artikelKennung = artikel.id;
            newPosition.menge = menge;
            newPosition.isMatrixArtikel = isMatrixArtikel;
    
            this.warenkorbsService.addPosition(newPosition).subscribe(res => {
                if (res != null) 
                {
                    
                  this.numberWarenkorbItems.emit(res.warenkorbPositionen.length);
                }
            });
        } else {
            const _title: string = "Anmelden";
            const _description: string = "Sie sind noch nicht angemeldet. Jetzt anmelden?";
    
            this.layoutUtilsService.qwertDialog(_title, _description, 'question', true, true, 'Anmelden').then(res => {
                if (res.dismiss) {
                    return;
                }

                this.authService.login();
                return;

            });
        }
    }

    toggledisplayheight() {
        $('.zub_artikel_list').toggleClass('expanded');        
    }

}
